module.exports = __webpack_public_path__ + "static/img/communicate.fe2cd67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/communicate.png
// module id = Xxre
// module chunks = 1